module.exports = __webpack_public_path__ + "static/media/fan-cleaning.92a89475.png";